import React from 'react'
import styled from 'styled-components'
import FormRouter from 'components/form/router'

const Form = styled.form``

export default () => (
  <Form onSubmit={e => e.preventDefault()}>
    <FormRouter />
  </Form>
)